const APP_VERSION = "4.31.6"

module.exports = APP_VERSION